import CookieBannerMapper from "../mappers/CookieBanner.mapper"
import axios from 'axios';
import CookieBannerConfiguration from "../models/CookieBannerConfiguration";

export default class ConfigurationService {
    public async getConfiguration(homePageID: string): Promise<CookieBannerConfiguration> {
        let api = axios.create({
            baseURL: ''
        })

        const data: any = await api.get('/CookieBanner/Config', { params: { "homePage": homePageID } });
        return new CookieBannerMapper().map(data.data);
    }
}